import { useEffect } from 'react';
import { prop, pick } from 'ramda';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import * as actions from '../store/actions';

export const useDetectLanguage = () => {
    const { path } = useParams();
    const userDispatch = useDispatch();
    const userLang = useUserSelector(prop('lang'));
    const { isChangeLangInProgress, stayOnLangSwitch } = useAppSelector(pick(['isChangeLangInProgress', 'stayOnLangSwitch']));

    useEffect(() => {
        if (isChangeLangInProgress && stayOnLangSwitch) {
            return;
        }

        const detectedLanguage = window.Playtech.Methods.getUserLanguage();

        if (userLang === detectedLanguage) {
            return;
        }

        userDispatch(actions.setLangAction(detectedLanguage));
    }, [path, userLang, userDispatch, isChangeLangInProgress, stayOnLangSwitch]);
};
